<template>
  <div class="step1 step">
    <div v-if="consumerAccount" class="oauth-notice">
      <div class="oauth-user">
        <img
          class="oauth-avatar"
          :src="consumerAvatarUrl"
          alt="avatar"
        >
        <div class="oauth-user-info">
          <p class="oauth-notice-title">
            {{ $t('createSellerAccount.step1.oauthLoginTitle', { account: consumerAccount }) }}
          </p>
          <p v-if="!hasExistingSeller" class="oauth-notice-desc">
            {{ $t('createSellerAccount.step1.oauthLoginDesc') }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="hasExistingSeller" class="existing-account">
      <p class="existing-account-title">
        {{ $t('createSellerAccount.step1.existingAccountTitle', { account: existingSellerName }) }}
      </p>
      <template v-if="showChooseStore">
        <p class="existing-account-desc">
          {{ $t('sc.components.chooseStore') }}
        </p>
        <Select
          v-model="store"
          clearable
          style="width: 200px"
          class="select"
        >
          <Option
            v-for="item in stores"
            :key="item.storeId"
            :value="JSON.stringify(item)"
          >
            {{ item.storeName }}
          </Option>
        </Select>
        <div class="existing-account-actions">
          <button
            type="button"
            class="myBtn confirmBtn"
            @click="storeLogin"
          >
            {{ $t('sc.components.login') }}
          </button>
        </div>
      </template>
      <template v-else>
        <p class="existing-account-desc">
          {{ $t('createSellerAccount.step1.existingAccountQuestion') }}
        </p>
        <div class="existing-account-actions">
          <button
            type="button"
            class="myBtn cancelBtn"
            @click="handleExistingAccountCancel"
          >
            {{ $t('createSellerAccount.step1.existingAccountCancel') }}
          </button>
          <button
            type="button"
            class="myBtn confirmBtn"
            @click="handleExistingAccountConfirm"
          >
            {{ $t('createSellerAccount.step1.existingAccountConfirm') }}
          </button>
        </div>
      </template>
    </div>
    <template v-else>
      <Vcode
        v-if="isShowVcode"
        :successText="$t('createSellerAccount.step1.successText')"
        :failText="$t('createSellerAccount.step1.failText')"
        :sliderText="$t('createSellerAccount.step1.sliderText')"
        :show="isShow"
        @success="onSuccess"
        @close="onClose"
      />
      <Form
        ref="formValidate"
        style="margin-right: 70px"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="140"
      >
        <div class="tips">
          Tips:{{ $t('createSellerAccount.step1.tips') }}
        </div>
        <!-- 帐号名 -->
        <FormItem
          :label="$t('createSellerAccount.step1.account')"
          prop="account"
        >
          <Input
            v-model.trim="formValidate.account"
            class="input-width"
            type="text"
          />
        </FormItem>
      <!-- 密码 -->
      <FormItem
        :label="$t('createSellerAccount.step1.pwd')"
        prop="pwd"
      >
        <Input
          v-model.trim="formValidate.pwd"
          type="password"
          password
        />
      </FormItem>
      <!-- 确认密码 -->
      <FormItem
        :label="$t('createSellerAccount.step1.confirmPwd')"
        prop="confirmPwd"
      >
        <Input
          v-model.trim="formValidate.confirmPwd"
          type="password"
          password
        />
      </FormItem>
      <Row :gutter="10">
        <Col span="14">
          <!-- 区号 -->
          <FormItem
            :label="$t('createSellerAccount.step1.phone')"
            prop="area"
          >
            <Select
              v-model="formValidate.area"
              :placeholder="$t('sc.storeSetting.selectCountry')"
            >
              <Avatar
                v-if="formValidate.area"
                slot="prefix"
                :src="
                  areaList.filter(
                    areaItem => areaItem.regionId === formValidate.area
                  )[0]?.flag || ''
                "
                size="small"
                shape="square"
              />
              <Option
                v-for="item in areaList"
                :key="item.regionId"
                :value="item.regionId"
              >
                <Avatar :src="item.flag" shape="square" />
                {{ item.name + '   +' + item.callingCode }}
              </Option>
              <!-- <Option :value="1">Bangladesh +880 </Option> -->
            </Select>
          </FormItem>
        </Col>
        <Col span="10">
          <!-- 手机号 -->
          <FormItem prop="phone" :label-width="0">
            <Row type="flex" :gutter="5">
              <Col span="14">
                <Input
                  v-model.trim="formValidate.phone"
                  :placeholder="
                    $t('createSellerAccount.step1.fillInPhoneNumber')"
                  type="tel"
                  :disabled="!formValidate.area || phoneLocked"
                  @on-keydown="keydownPhone"
                />
              </Col>
              <Col span="10">
                <SendCode ref="sendCode" @click.native="sendCode" />
              </Col>
            </Row>
          </FormItem>
        </Col>
      </Row>
      <!-- 验证码 -->
      <FormItem :label="$t('createSellerAccount.step1.code')" prop="code">
        <Input v-model.trim="formValidate.code" placeholder="" type="text" />
      </FormItem>
      <!-- 商户类型 -->
      <FormItem
        :label="$t('createSellerAccount.step1.sellerType')"
        prop="merchantType"
      >
        <Select
          v-model="formValidate.merchantType"
          placeholder=""
        >
          <Option :value="2">
            {{ $t('createSellerAccount.step1.businessIfYou') }}
          </Option>
          <Option
            v-if="formValidate.area !== 2"
            :value="1"
          >
            {{ $t('createSellerAccount.step1.individualIfYou') }}
          </Option>
        </Select>
      </FormItem>
      <!-- 座机 -->
      <!-- <FormItem
        :label="$t('createSellerAccount.step1.telephone')"
        prop="telephone"
      >
        <Input
          v-model.trim="formValidate.telephone"
          type="tel"
        />
      </FormItem> -->
      <!-- 传真 -->
      <!-- <FormItem
        :label="$t('createSellerAccount.step1.fax')"
        prop="fax"
      >
        <Input
          v-model="formValidate.fax"
          type="tel"
        />
      </FormItem> -->
      <!-- 邮箱 -->
      <FormItem
        :label="$t('createSellerAccount.step1.email')"
        prop="email"
      >
        <div class="line-box">
          <Input
            v-model.trim="formValidate.email"
            placeholder=""
            type="email"
          />
          <span>
            {{ $t('createSellerAccount.step1.useToReceiveAccountRelated') }}
          </span>
        </div>
      </FormItem>
      <!-- 推荐码 -->
      <FormItem
        :label="$t('createSellerAccount.step1.referralCode')"
      >
        <Input
          v-model.trim="formValidate.referenceNo"
          placeholder=""
          type="text"
        />
      </FormItem>
      </Form>
      <div class="tc">
        <!-- 下一步 -->
        <button
          type="button"
          class="sendCodeBtn myBtn"
          :disabled="clicked"
          @click="handleSubmit('formValidate')"
        >
          {{ $t('createSellerAccount.next') }}
        </button>
      </div>
    </template>
    <div v-if="consumerAccount && !hasExistingSeller" class="oauth-reminder">
      <p
        class="oauth-reminder-title"
        v-html="oauthReminderHtml"
      />
    </div>
  </div>
</template>

<script>
import SendCode from '_c/global/send-code.vue'
import { checkAccount, login } from '_h/account'
import { smsCode, checkSms, newSignUp } from '_h/public'
import { isValidPhoneNumber } from 'libphonenumber-js'
import {
  handleLoginSuccess,
  storeLogin as storeLoginFlow
} from '@/utils/login-flow'
export default {
  components: {
    SendCode,
    Vcode: () => import('vue-puzzle-vcode')
  },
  data() {
    return {
      isShow: false,
      sn: '',
      clicked: false, // 下一步按钮状态
      showChooseStore: false,
      store: '',
      stores: [],
      areaList: [],
      sellerInfo: null,
      phoneLocked: false,
      defaultAvatar: require('@/assets/img/header/user.png'),
      formValidate: {
        account: '',
        pwd: '',
        confirmPwd: '',
        area: '',
        email: '',
        phone: '',
        code: '',
        merchantType: '',
        telephone: '',
        fax: '',
        referenceNo: ''
      },
      isShowVcode: false
    }
  },
  computed: {
    consumerAccount() {
      if (!this.sellerInfo || !this.sellerInfo.oauthUser) {
        return ''
      }
      const user = this.sellerInfo.oauthUser
      return user.nick || user.email || user.phone || ''
    },
    oauthReminderHtml() {
      const account = this.escapeHtml(this.consumerAccount)
      const accountHtml = `<strong>${account}</strong>`
      const title = this.$t('createSellerAccount.step1.oauthBindTitle', {
        account: accountHtml
      })
      const desc = this.$t('createSellerAccount.step1.oauthBindDesc', {
        account: accountHtml
      })
      return `${title} ${desc}`.trim()
    },
    consumerAvatar() {
      if (!this.sellerInfo || !this.sellerInfo.oauthUser) {
        return ''
      }
      return this.sellerInfo.oauthUser.avatar || ''
    },
    consumerAvatarUrl() {
      return this.consumerAvatar || this.defaultAvatar
    },
    verificationToken() {
      return this.sellerInfo && this.sellerInfo.verificationToken
        ? this.sellerInfo.verificationToken
        : ''
    },
    hasExistingSeller() {
      return !!(this.sellerInfo && this.sellerInfo.sellerInfo)
    },
    existingSellerName() {
      return this.sellerInfo && this.sellerInfo.sellerInfo
        ? this.sellerInfo.sellerInfo.name || ''
        : ''
    },
    ruleValidate() {
      // 自定义表单验证
      const checkAccountValidator = (rule, value, callback) => {
        if (!/^\w{4,}$/.test(value) || !value) {
          callback(new Error(this.$t('createSellerAccount.step1.reluMsgAccount')))
        } else {
          this.$axios.request(checkAccount(value)).then(res => {
            if (Number(res.data.code) === 0) {
              // 账号已被注册
              if (res.data.data.exist) {
                callback(new Error(this.$t('createSellerAccount.step1.reluMsgRegistered')))
              } else callback() // 未被注册
            }
          })
        }
      }
      const phoneValidator = (rule, value, callback) => {
        if (!value) {
          return callback(
            new Error(this.$t('createSellerAccount.step1.reluMsgPhone'))
          )
        }
        const selectItem = this.areaList.filter(
          item => item.regionId === this.formValidate.area
        )
        const validNum = value.replace(/\b(0+)/gi, '')
        const phoneNumber = isValidPhoneNumber(validNum, selectItem[0].code)
        if (!phoneNumber) {
          return callback(
            new Error(this.$t('createSellerAccount.step1.reluMsgPhone'))
          )
        }
        return callback()
      }
      return {
        account: [
          {
            required: true,
            trigger: 'blur',
            validator: checkAccountValidator
          }
        ],
        pwd: [
          {
            required: true,
            message: this.$t('createSellerAccount.step1.reluMsgPwd'),
            trigger: 'blur',
            min: 6
          }
        ],
        confirmPwd: [
          {
            required: true,
            message: this.$t('createSellerAccount.step1.reluMsgConfirmPwd'),
            trigger: 'blur',
            min: 6,
            pattern: new RegExp() // 通过watch或updated修改
          }
        ],
        area: [
          {
            type: 'number',
            required: true,
            message: this.$t('createSellerAccount.step1.reluMsgareaCode'),
            trigger: 'change'
          }
        ],
        email: [
          {
            message: this.$t('createSellerAccount.step1.reluMsgEmail'),
            trigger: 'blur',
            pattern: /.+@.+/
          }
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator: phoneValidator
          }
        ],
        code: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('createSellerAccount.step1.reluMsgCode')
          }
        ],
        merchantType: [
          {
            type: 'number',
            required: true,
            message: this.$t('createSellerAccount.step1.reluMsgMerchantType'),
            trigger: 'change'
          }
        ],
        telephone: [
          {
            required: false,
            message: this.$t('createSellerAccount.step1.reluMsgTelephone'),
            trigger: 'blur'
          }
        ],
        fax: [
          {
            required: false,
            message: this.$t('createSellerAccount.step1.reluMsgFax'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    'formValidate.pwd'(newVal) {
      this.ruleValidate.confirmPwd[0].pattern = new RegExp(`^${newVal}$`)
    },
    'formValidate.code'() {
      this.clicked = false
    }
  },
  mounted() {
    this.sn = this.$cookies.get('sn-register')
    this.getArea()
    this.loadSellerInfo()
  },
  methods: {
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    loadSellerInfo() {
      try {
        if (sessionStorage.getItem('oauth_flow_enabled') !== '1') {
          this.sellerInfo = null
          return
        }
        const raw = sessionStorage.getItem('oauth_seller_info')
        const expireAt = Number(sessionStorage.getItem('oauth_seller_info_expire_at'))
        if (expireAt && Date.now() / 1000 > expireAt) {
          sessionStorage.removeItem('oauth_seller_info')
          sessionStorage.removeItem('oauth_seller_info_expire_at')
          this.sellerInfo = null
          return
        }
        this.sellerInfo = raw ? JSON.parse(raw) : null
      } catch (error) {
        console.error('oauth seller info parse error:', error)
        this.sellerInfo = null
      }
      this.syncSellerInfoToForm()
    },
    syncSellerInfoToForm() {
      if (!this.sellerInfo || !this.sellerInfo.oauthUser) {
        return
      }
      const user = this.sellerInfo.oauthUser
      if (!this.formValidate.email && user.email) {
        this.formValidate.email = user.email
      }
      if (user.phone) {
        if (!this.formValidate.phone) {
          this.formValidate.phone = user.phone
        }
        this.phoneLocked = true
      }
      if (!this.formValidate.area && user.regionCode && this.areaList.length) {
        const areaItem = this.areaList.find(item => {
          return item.code === user.regionCode ||
            item.regionCode === user.regionCode ||
            item.isoCode === user.regionCode
        })
        if (areaItem) {
          this.formValidate.area = areaItem.regionId
        }
      }
    },
    onSuccess() {
      this.isShow = false
      this.getSmsCode()
    },
    onClose() {
      this.isShow = false
    },
    // 获取开放的国家
    getArea() {
      this.$axios
        .get('/national-stations', {
          params: {
            stationType: 1
          }
        })
        .then(response => {
          this.areaList = response.data.data
          this.syncSellerInfoToForm()
        })
        .catch(error => {
          console.error(error)
          const err = error.response
          this.spinShow = false
          if (err.status > 500) {
            this.$Message.error(err.status + err.statusText)
          }
          if (err) {
            if (err.data.msg) {
              this.$Message.error(err.data.msg)
            }
          }
        })
    },
    handleSubmit(name) {
      const phone = this.formValidate.phone.replace(/\b(0+)/gi, '')
      this.$refs[name].validate(async(valid) => {
        if (valid) {
          // 禁用按钮
          this.clicked = true
          if (this.sn) {
            const smsParams = {
              sn: this.sn,
              code: this.formValidate.code,
              phone,
              regionId: this.formValidate.area
            }
            try {
              const checkRes = await this.$axios.request(checkSms(smsParams))
              if (!checkRes.data.data.isVerify) {
                this.clicked = false
                this.$Message.error('createSellerAccount.step1.checkFaild')
                return
              }
              // 清除cookie：sn-register
              this.$cookies.remove('sn-register')
              this.signUpFn(phone)
            } catch (error) {
              console.error(error)
              this.$handleError(this, error)
              this.clicked = false
              this.formValidate.code = ''
              this.$Message.error(this.$t('createSellerAccount.step1.reluMsgCheckCode'))
            }
          } else {
            this.clicked = false
            this.$Message.error(this.$t('createSellerAccount.step1.reluMsgCheckSN'))
          }
        }
      })
    },
    async signUpFn(phone) {
      const signParams = {
        account: this.formValidate.account,
        password: this.formValidate.confirmPwd,
        sellerType: this.formValidate.merchantType,
        phoneRegionId: this.formValidate.area,
        phone,
        email: this.formValidate.email,
        referenceNo: this.formValidate.referenceNo,
        verificationToken: this.verificationToken
      }
      const loginParams = {
        loginType: 1,
        account: this.formValidate.account,
        password: this.formValidate.confirmPwd
      }
      try {
        const signRes = await newSignUp(this.$axios, signParams)
        if (signRes.code === 0) {
          const loginRes = await this.$axios.request(login(loginParams))
          // 存cookie
          this.$SetCookieFn('user-token', loginRes.data.data.token)
          // this.$SetCookieFn('user-refresh-token', res.data.data.refreshToken)
          this.$SetCookieFn('user-account', loginRes.data.data.account)
          this.$SetCookieFn('user-id', loginRes.data.data.userId)
          this.$SetCookieFn('seller-type', loginRes.data.data.seller.sellerType)
          this.$SetCookieFn('seller-id', loginRes.data.data.seller.sellerId)
          this.$SetCookieFn('account-type', loginRes.data.data.accountType)
          this.$SetCookieFn(
            'region-id',
            loginRes.data.data.seller.sellerRegionId
          )
          this.$SetCookieFn('sellerRegionId', loginRes.data.data.seller.sellerRegionId)
          loginRes.data.data.email && this.$SetCookieFn('account-email', loginRes.data.data.email)
          sessionStorage.removeItem('oauth_seller_info')
          sessionStorage.removeItem('oauth_seller_info_expire_at')
          sessionStorage.removeItem('oauth_flow_enabled')
          this.$router.push('/create-seller-account/step2')
        }
      } catch (error) {
        console.error(error)
        this.$handleError(this, error)
      }
    },
    sendCode() {
      const fieldNameArr = ['phone', 'area']
      Promise.all(fieldNameArr.map(item => {
        const p = new Promise((resolve, reject) => {
          this.$refs.formValidate.validateField(item, error => {
            resolve(error)
          })
        })
        return p
      })).then((data) => {
        if (data[0] || data[1]) {
          return
        }
        if (this.$refs.sendCode.timer === null) {
          // 去掉电话最前面的0
          this.isShowVcode = this.isShow = true
        }
      })
    },
    getSmsCode() {
      // 防止请求过程中重复点击
      this.$refs.sendCode.isSending = true
      const phoneNum = this.formValidate.phone
      this.$axios
        .request(smsCode({
          type: 3,
          regionId: this.formValidate.area,
          phone: phoneNum.replace(/\b(0+)/gi, '')
        }))
        .then(res => {
          if (Number(res.data.code) === 0) {
            this.sn = res.data.data.sn
            this.$SetCookieFn('sn-register', res.data.data.sn, {
              maxAge: 60 * 15
            })
            // 发送成功再计时
            this.$refs.sendCode.countDown()
          } else {
            this.$refs.sendCode.isSending = false
            if (res.data.msg) {
              this.$Message.error(res.data.msg)
            }
          }
        })
        .catch(error => {
          console.error(error)
          this.$refs.sendCode.isSending = false
          const err = error.response
          if (err && err.data && err.data.msg) {
            this.$Message.error(err.data.msg)
          }
        })
    },
    keydownPhone(event) {
      if (event.keyCode === 32) {
        event.returnValue = false
      }
    },
    handleExistingAccountCancel() {
      this.$router.push('/')
    },
    async handleExistingAccountConfirm() {
      try {
        const res = await this.$axios.post('/oauth2/login', {
          verificationToken: this.verificationToken
        })
        if (Number(res.data.code) === 0) {
          handleLoginSuccess(this, res.data.data)
        } else {
          this.$Message.error(res.data.msg || 'Login failed')
        }
      } catch (error) {
        console.error(error)
        this.$handleError(this, error)
      }
    },
    storeLogin() {
      return storeLoginFlow(this)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  font-size: $f14;
  color: $inactive;
  margin-bottom: 0.3rem;
  text-align: center;
  width: 100%;
  margin-left: 40px;
}
.oauth-notice,
.oauth-reminder {
  margin: 0.12rem 0 0.24rem;
  text-align: center;
}
.oauth-user {
  display: flex;
  align-items: center;
  gap: 0.12rem;
  justify-content: center;
}
.oauth-avatar {
  width: 0.44rem;
  height: 0.44rem;
  border-radius: 50%;
  border: 1px solid #f1b7bb;
  background: #fff;
  object-fit: cover;
}
.oauth-user-info {
  text-align: left;
}
.oauth-notice-title {
  line-height: 1.5;
  color: #d04a44;
}
.oauth-notice-desc {
  margin-top: 0.06rem;
  font-size: 0.12rem;
  line-height: 1.5;
  color: #d04a44;
}
.oauth-reminder-title {
  line-height: 1.5;
  color: #d04a44;
}
.oauth-reminder-desc {
  margin-top: 0.06rem;
  font-size: 0.12rem;
  line-height: 1.5;
  color: #d04a44;
}
.existing-account {
  margin: 0.4rem auto;
  text-align: center;
  color: #333;
}
.existing-account-title {
  font-size: 0.16rem;
  font-weight: 600;
  margin-bottom: 0.12rem;
}
.existing-account-desc {
  font-size: 0.13rem;
  margin-bottom: 0.2rem;
}
.existing-account-actions {
  display: flex;
  justify-content: center;
  gap: 0.16rem;
}
.existing-account-actions .myBtn {
  min-width: 1.1rem;
  padding: 0.08rem 0.2rem;
  border-radius: 4px;
  border: 1px solid transparent;
}
.existing-account-actions .cancelBtn {
  background: #fff;
  border-color: #d8d8d8;
  color: #666;
}
.existing-account-actions .confirmBtn {
  background: #d04a44;
  border-color: #d04a44;
  color: #fff;
}
.input-width {
  width: 385px;
}
.step1 {
  .line-box {
    display: flex;
    align-items: center;
    /deep/ .ivu-input,  /deep/.ivu-input-wrapper {
      width: 170px;
    }
    span {
      margin-left: 5px;
      white-space: nowrap;
      color: #999;
    }
  }
}
</style>
